import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { Language } from "src/app/shared/models/language";
import { TextBlock } from "src/app/shared/models/text-block";
import { PublicSurveyService } from "src/app/shared/services/public-survey.service";
import { PublicTextBlockService } from "src/app/shared/services/public-text-block.service";
import { validateForm } from "src/app/shared/validators";

@Component({
    selector: "app-search-by-key-page",
    templateUrl: "./search-by-key-page.component.html",
    styleUrls: ["./search-by-key-page.component.scss"],
    standalone: false
})
export class SearchByKeyPageComponent implements OnInit {
  loginForm: UntypedFormGroup;
  errorMessage: string;
  instructions: TextBlock;
  languages: Language[];
  indicatorType: number;

  constructor(
    private fb: UntypedFormBuilder,
    private publicSurveyService: PublicSurveyService,
    private publicTextBlockService: PublicTextBlockService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  async ngOnInit(): Promise<void> {
    this.loginForm = this.fb.group({
      surveyKey: [
        "",
        {
          validators: [Validators.required],
        },
      ],
      languageId: [
        "en",
        {
          validators: [Validators.required],
        },
      ],
    });

    this.indicatorType = Number(
      this.route.snapshot.paramMap.get("indicatorType")
    );

    this.languages = await this.publicSurveyService
      .getLanguagesForCurrentSurvey("pso")
      .toPromise();

    this.instructions = await this.publicTextBlockService
      .getBlock("survey-instructions")
      .toPromise();
  }

  async onSubmit() {
    this.errorMessage = null;

    this.loginForm.markAllAsTouched();
    this.loginForm.updateValueAndValidity();

    if (this.loginForm.valid) {
      await this.publicSurveyService
        .search(this.loginForm.get("surveyKey").value)
        .toPromise()
        .then((administrativeUnitSurveyId: string) => {
          this.router.navigate([
            "public",
            "surveys",
            this.indicatorType,
            this.loginForm.get("languageId").value,
            administrativeUnitSurveyId,
          ]);
        })
        .catch((error: any) => {
          if (error.status === 404) {
            this.errorMessage = "Survey not found, please check key.";
          } else {
            this.errorMessage = "Error getting survey, please try again.";
          }
        });
    }
  }

  getErrorMessage(key: string): string {
    return validateForm(this.loginForm, key);
  }
}
